/**
 * Tipos de Localidade
 * @enum {typeof EnumTiposLocal[keyof typeof EnumTiposLocal] }
 */

export const EnumTiposLocal = Object.freeze({
    Geral: 0,

    Terminal: 1,

    Deposito: 2,
    Fabrica: 3,
    Patio: 4,
    Pilha: 5,
    Slot: 6,
    Quadra: 7,
    Baia: 8,
    Prateleira: 9,
    Posicao: 10,
    Portao: 11,
    Armazem: 12,
    ArmazemPorto: 13,
    Fileira: 14,
    Coluna: 15,
    Cancelado: 16,
    UnidadeMarimex: 17,
    Doca: 18,
    Municipio: 19,
    QuadraDoSlot: 20,
    Origem: 21,
    Destino: 22,
    LadoDaPilha: 23,
    Fila: 24,
    Altura: 25,
    CatracaTorniquete: 26
});
